import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import es from 'vuetify/lib/locale/es'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true, // Tema oscuro por defecto
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#eceff1',
        secondary: '#00003c',
        accent: '#1a05a3',
        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        anchor: '#00003c',
        eon: '#f68632',
      },
      dark: {
        // Paleta base del tema oscuro
        background: '#121212',
        surface: '#1E1E1E',
        primary: '#2E2E2E',
        secondary: '#BB86FC', // Se sobrescribirá por módulo
        accent: '#03DAC6', // Se sobrescribirá por módulo
        error: '#CF6679',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        anchor: '#BB86FC', // Se sobrescribirá por módulo
        text: '#FFFFFF',
        eon: '#f68632',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'mdi',
  },
})
